// CSS
import "./styles/global.scss";

import $ from 'jquery';
require('jquery-validation');
require('datatables.net');
require('datatables.net-dt');

require('../node_modules/dsd-template_header/js/global.js');
require('../node_modules/dsd-template_forms/js/global.js');
require('../node_modules/dsd-template_accordions/js/global.js');
require('../node_modules/dsd-template_latest-news/js/global.js');
require('../node_modules/dsd-template_quick-links/js/global.js');
require('../node_modules/dsd-template_alerts/js/global.js');